<!-- 监测数据 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1" class="head-text">样式设置</MenuItem>
                <MenuItem name="2" class="head-text">内容设置</MenuItem>
                <MenuItem name="3" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <div v-if="name_id == 1">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="100"
                    >
                        <div class="form-title">选择样式</div>
                        <FormItem label="选择样式">
                            <RadioGroup
                                v-model="newFormData.content.style_value"
                            >
                                <Radio class="mr24" label="1">样式一</Radio>
                                <Radio class="mr24" label="2">样式二</Radio>
                            </RadioGroup>
                        </FormItem>
                        <template v-if="newFormData.content.style_value == 2">
                            <div class="form-title">菜单设置</div>
                            <FormItem label="文字大小">
                                <Input
                                    v-model="newFormData.content.title_size"
                                    placeholder="请输入文字大小"
                                    ><span slot="append">PX</span></Input
                                >
                            </FormItem>
                            <FormItem label="选中文字">
                                <ColorPicker
                                    v-model="
                                        newFormData.content.title_color_active
                                    "
                                />
                            </FormItem>
                            <FormItem label="选中背景">
                                <ColorPicker
                                    v-model="
                                        newFormData.content
                                            .title_bg_color_active
                                    "
                                />
                            </FormItem>
                            <FormItem label="未选中文字">
                                <ColorPicker
                                    v-model="newFormData.content.title_color"
                                />
                            </FormItem>
                            <FormItem label="背景色">
                                <ColorPicker
                                    v-model="newFormData.content.title_bg_color"
                                />
                            </FormItem>
                            <div class="form-title">其他设置</div>
                            <FormItem label="备注信息">
                                <ColorPicker
                                    v-model="newFormData.content.remark_color"
                                />
                            </FormItem>
                            <FormItem label="图例文字">
                                <ColorPicker
                                    v-model="newFormData.content.other_color"
                                />
                            </FormItem>
                        </template>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色">
                            <ColorPicker
                                v-model="newFormData.content.bg_color"
                            />
                        </FormItem>
                        <FormItem label="背景图">
                            <i-switch
                                v-model="newFormData.content.bg_value"
                                size="large"
                                true-color="var(--primary-color) "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeBgValue"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.bg_value"
                            label="上传背景"
                        >
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.bg_img.picview"
                                    :src="newFormData.content.bg_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <template v-if="newFormData.content.style_value == 2">
                            <div class="form-title">菜单内容</div>
                            <div class="right-navs">
                                <div
                                    class="right-nav"
                                    v-for="(item, index) of newFormData.content
                                        .menuList"
                                    :key="index"
                                >
                                    <img
                                        class="del-img"
                                        src="@/assets/del.png"
                                        @click.stop="delIcon(index)"
                                    />
                                    <FormItem label="菜单名称">
                                        <Input
                                            v-model="item.title"
                                            placeholder="请输入菜单名称"
                                        ></Input>
                                    </FormItem>
                                    <FormItem label="备注信息">
                                        <Input
                                            v-model="item.remark"
                                            placeholder="请输入备注信息"
                                        ></Input>
                                    </FormItem>
                                </div>
                                <div class="add-div" @click="addIcon">
                                    <img
                                        class="add-img"
                                        src="@/assets/plus.png"
                                    />
                                    <div class="add-txt">添加</div>
                                </div>
                            </div>
                        </template>
                        <div
                            v-if="newFormData.content.style_value == 1"
                            class="form-title"
                        >
                            内容设置
                        </div>
                        <div
                            v-else-if="newFormData.content.style_value == 2"
                            class="form-title"
                        >
                            仪表盘内容
                        </div>
                        <div class="right-navs">
                            <div
                                class="right-nav"
                                v-for="(item, index) of newFormData.content
                                    .menuList"
                                :key="index"
                            >
                                <img
                                    class="del-img"
                                    src="@/assets/del.png"
                                    @click.stop="delIcon(index)"
                                />
                                <FormItem label="检测名称">
                                    <Input
                                        v-model="item.text.name"
                                        placeholder="请输入检测名称"
                                    ></Input>
                                </FormItem>
                                <FormItem label="检测数据">
                                    <Input
                                        v-model="item.text.txt"
                                        placeholder="请输入检测数据"
                                    ></Input>
                                </FormItem>
                                <FormItem label="参考标准">
                                    <Input
                                        v-model="item.text.norm"
                                        placeholder="请输入参考标准"
                                    ></Input>
                                </FormItem>
                            </div>
                            <div class="add-div" @click="addIcon">
                                <img class="add-img" src="@/assets/plus.png" />
                                <div class="add-txt">添加</div>
                            </div>
                        </div>
                        <FormItem label="名称大小">
                            <Input
                                v-model="newFormData.content.name_size"
                                placeholder="请输入名称大小"
                                ><span slot="append">PX</span></Input
                            >
                        </FormItem>
                        <FormItem label="名称颜色">
                            <ColorPicker
                                v-model="newFormData.content.name_color"
                            />
                        </FormItem>
                        <FormItem label="数据大小">
                            <Input
                                v-model="newFormData.content.txt_size"
                                placeholder="请输入数据大小"
                                ><span slot="append">PX</span></Input
                            >
                        </FormItem>
                        <FormItem label="数据颜色">
                            <ColorPicker
                                v-model="newFormData.content.txt_color"
                            />
                        </FormItem>
                        <template v-if="newFormData.content.style_value == 1">
                            <FormItem label="参考标准">
                                <Input
                                    v-model="newFormData.content.norm_size"
                                    placeholder="请输入参考标准"
                                    ><span slot="append">PX</span></Input
                                >
                            </FormItem>
                            <FormItem label="参考颜色">
                                <ColorPicker
                                    v-model="newFormData.content.norm_color"
                                />
                            </FormItem>
                            <FormItem label="装饰颜色">
                                <ColorPicker
                                    v-model="newFormData.content.border_color"
                                />
                            </FormItem>
                        </template>
                    </Form>
                </div>
                <div v-if="name_id == 3">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">内间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="下圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.bottom"
                            ></Slider
                        ></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
        };
    },
    mounted() {},
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
        // 添加
        addIcon() {
            this.newFormData.content.menuList.push({
                title: "菜单名称",
                text: { name: "检测名称", txt: "检测数据", norm: "参考标准" },
            });
        },
        // 删除
        delIcon(i) {
            if (this.newFormData.content.menuList.length == 1) {
                this.$Message.info("至少保留一个");
            } else {
                this.newFormData.content.menuList.splice(i, 1);
            }
        },
    },
};
</script>


<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: var(--primary-color);
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
/* RadioGroup */
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #fff;
    border-color: var(--primary-color);
    color: var(--primary-color);
    box-shadow: -1px 0 0 0 var(--primary-color);
}
::v-deep .ivu-radio-group-button :hover {
    color: var(--primary-color);
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
::v-deep .ivu-slider-bar {
    background-color: var(--primary-color);
}
::v-deep .ivu-slider-button {
    border: 2px solid var(--primary-color);
}
.right-navs {
    padding: 12px;
    width: 100%;
    border: 1px solid #c0c4cc;
    margin-bottom: 12px;
}
.right-nav {
    padding: 12px;
    margin-bottom: 12px;
    border: 1px solid #c0c4cc;
    position: relative;
}
.del-img {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99;
    cursor: pointer;
    width: 30px;
    height: 30px;
}
.add-div {
    display: flex;
    cursor: pointer;
}
.add-img {
    width: 22px;
    height: 22px;
    margin-right: 6px;
}
.add-txt {
    font-size: 15px;
    color: var(--primary-color);
}
</style>